<template>
  <div class="express">
    <!-- 快递规则 -->
    <div class="express-content">
      <div class="express-rules">
        <div class="express-rules-top">
          <div class="express-rules-top-left">
            <p class="express-rules-top-left-title">服务仓库：{{ warehouseName }}</p>
            <p class="express-rules-top-left-title">快递类型：{{ logisticsForm.expressName }}</p>
            <p class="express-rules-top-left-title">计费类型：{{ logisticsForm.expressMethodName }}</p>
          </div>
          <div v-if="isFlag !== 3" class="express-rules-top-right set-template" @click="openSetTemplateDrawer">
            <img class="queue" src="../../assets/images/edit/edit.png">
            设为模板
          </div>
          <div v-if="isFlag !== 3" class="express-rules-top-right" @click="openTemplateDrawer">
            <img class="queue" src="../../assets/images/express-rule/queue-black.png">
            选用模板
          </div>
        </div>
        <div class="express-rules-main">
          <div class="express-rules-content">
            <div class="express-rules-content-left">
              <div class="table-name-content">
                <div class="table-name" :class="{'table-name-active': activeTableIndex == index}"
                  v-for="(item, index) in tableList" :key="index" @click="selectTable(item, index)">
                  <span class="name">{{item.name}}</span>
                  <img v-if="isFlag !== 3" @click.stop="closeTable(index)" class="close"
                    src="../../assets/images/close.png">
                </div>
              </div>
              <div v-if="isFlag !== 3" class="add-table-content">
                <div class="add-table" @click="addTable">
                  <span class="add-rectangle"></span>
                  <span>新增表格</span>
                </div>
              </div>
            </div>
            <div class="express-rules-content-right">
              <p class="express-rules-content-right-title">取整规则</p>
              <div class="rule-main">
                <div class="rule-item" v-for="(value, index) in expressRuleRoundTypeReqVoList" :key="index">
                  <span class="section-name">区间{{ index + 1 }}</span>
                  <div class="interval">
                    <el-input class="w88" v-model="value.begin" disabled></el-input>
                    <span class="blank">—</span>
                    <el-input class="w88" v-model="value.end" @blur="blurRoundTableTitle(index, value.end)" :disabled="
                      isFlag === 3 ? true : (
                        index === expressRuleRoundTypeReqVoList.length - 1
                          ? (value.end >= 9999.9?true:false)
                          : false)
                      " @input="inputRoundEnd(index, value.end)"></el-input>
                    <div class="throw-rule">
                      <span>取整规则：</span>
                      <div class="input-container">
                        <el-select class="w94" v-model="value.roundType" :disabled="isFlag === 3">
                          <el-option v-for="item in roundList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <img class="close-section" src="../../assets/images/close.png" v-show="isFlag !== 3 && (index !== 0?
                        index === expressRuleRoundTypeReqVoList.length - 1
                        : false)
                      " @click="deleteSection(index)">
                  </div>
                </div>
              </div>
              <div class="add-section" v-if="isFlag !== 3 && expressRuleRoundTypeReqVoList.length > 0">
                <el-button type="text" class="btn-text" @click="addSection">+添加区间</el-button>
              </div>
            </div>
          </div>
          <div class="express-rules-table">
            <div class="express-rules-table-title">
              <span class="table-name">{{ tableName }}</span>
              <div v-if="isFlag !== 3" class="edit-table-section" :class="{'disable-section':!tableList.length}"
                @click="openEditSectionDrawer">
                <img src="../../assets/images/edit.png">
                <span>编辑区间</span>
              </div>
            </div>
            <div class="table-img">
              <el-table :data="tableData" style="width: 100%">
                <template slot="empty">
                  <div v-if="tableTitle.length">
                    <span>暂无数据，可先进行</span>
                    <el-button class="btn-text" type="text" :disabled="isFlag === 3"
                      @click="addTableData">添加</el-button>
                    <span>列</span>
                  </div>
                </template>
                <el-table-column label="序号" width="80">
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column label="地区">
                  <template slot-scope="scope">
                    <div class="province-name">
                      <span class="area-name" :class="{ 'province-active': scope.row.province }">
                        <tool-tip v-bind="{ txtInfo: scope.row.province }">
                        </tool-tip>
                      </span>
                      <span v-if="isFlag !== 3" class="mod-area" @click="openModArea(scope.$index, scope.row.province)">前往编辑</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="区间1" v-if="tableTitle.length === 0"></el-table-column>
                <el-table-column label="区间2" v-if="tableTitle.length === 0"></el-table-column>
                <el-table-column v-for="(title, index) in tableTitle" :key="index" :label="
                    index + 1 === tableTitle.length
                      ? title.value + unit
                      : title.value + unit
                  ">
                  <el-table-column v-if="title.fixedPrice" :label="`首重（元/${unit}）`">
                    <template slot-scope="scope">
                      <el-input class="white" :class="{'province-active':scope.row[title.value]}"
                        v-model="scope.row[title.value]" placeholder="请输入" @input="
                          inputPriceLimit(
                            scope.row,
                            title.value,
                            'fixedPrice',
                            scope.row[title.value]
                          )
                        " :disabled="isFlag === 3"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="!title.fixedPrice" :label="`首重（元/${unit}）`">
                    <template slot-scope="scope">
                      <el-input class="white" :class="{'province-active':scope.row[title.value].firstWeight}"
                        v-model="scope.row[title.value].firstWeight" placeholder="请输入" @input="
                          inputPriceLimit(
                            scope.row,
                            title.value,
                            'firstWeight',
                            scope.row[title.value].firstWeight
                          )
                        " :disabled="isFlag === 3"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="!title.fixedPrice" :label="`续重（元/${unit}）`">
                    <template slot-scope="scope">
                      <el-input class="white" :class="{'province-active':scope.row[title.value].overPrice}"
                        v-model="scope.row[title.value].overPrice" placeholder="请输入" @input="
                          inputPriceLimit(
                            scope.row,
                            title.value,
                            'overPrice',
                            scope.row[title.value].overPrice
                          )
                        " :disabled="isFlag === 3"></el-input>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column class-name="btn" label="操作" v-if="isFlag !== 3">
                  <template slot-scope="scope">
                    <el-button class="btn-text" type="text" @click="removeTableData(scope.$index)">删除</el-button>
                    <el-button v-if="scope.$index === tableData.length - 1" class="btn-text" type="text"
                      @click="addTableData">添加</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="express-footer" v-if="isFlag !== 3">
      <el-button v-if="isFlag === 1 && logisticsForm.expressMethod != 2" class="btn-white"
        @click="saveExpressRules">保存</el-button>
      <el-button v-if="isFlag === 1 && logisticsForm.expressMethod == 2" class="btn-white"
        @click="saveScenePriceExpressRules">保存</el-button>
    </div>

    <!-- 设为模板 -->
    <el-drawer class="template-drawer" title="设为模板" :wrapperClosable="false" :visible.sync="setTemplateDrawer"
      :before-close="handleCloseSetTemplateDrawer">
      <el-form ref="setTemplateForm" :rules="setTemplateFormRules" :model="setTemplateForm">
        <el-form-item label="模板名称" prop="templateName">
          <el-input v-model="setTemplateForm.templateName" placeholder="请输入模板名称"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseSetTemplateDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submitSetTemplateDrawerForm('setTemplateForm')">确定</el-button>
      </div>
    </el-drawer>

    <!-- 使用模板 -->
    <el-drawer class="template-drawer" title="使用模板" :wrapperClosable="false" :visible.sync="templateDrawer"
      :before-close="handleCloseTemplateDrawer">
      <el-form ref="templateForm" :model="templateForm">
        <el-form-item label="模板名称" prop="templateId">
          <el-select v-model="templateForm.templateId" placeholder="请选择">
            <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseTemplateDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submitTemplateForm('templateForm')">确定</el-button>
      </div>
    </el-drawer>

    <!-- 编辑区间 -->
    <el-drawer class="edit-section-drawer" title="编辑区间" :wrapperClosable="false" :visible.sync="editSectionDrawer"
      :before-close="handleCloseEditSectionDrawer">
      <div class="section-main">
        <div class="section-item" v-for="(value, index) in sectionList" :key="index">
          <span class="section-name">首重区间{{ index + 1 }}</span>
          <p class="interval">
            <el-input class="w88" v-model="value.begin" disabled></el-input>
            <span class="blank">—</span>
            <el-input class="w88" v-model="value.end" @blur="blurTableTitle(index, value.end)" :disabled="
                index === sectionList.length - 1
                  ? true
                  : false
              "></el-input>
            <span class="first-weight">首重</span>
            <el-input class="w114" v-model="value.unitWeight" placeholder="输入值≤左区间" :disabled='index === 0'></el-input>
            <el-checkbox class="fixedPrice" v-model="value.fixedPrice">固定价</el-checkbox>
            <img class="close-section" src="../../assets/images/close.png" v-show="index !== 0?
                index === sectionList.length - 2
                : false
              " @click="delTableSection(index)">
          </p>
        </div>
        <div class="add-section">
          <el-button type="text" class="btn-text" @click="addTableSection">+添加区间</el-button>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseEditSectionDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submitEditSectionDrawer">确定</el-button>
      </div>
    </el-drawer>


    <!-- 添加/编辑地区，添加/编辑区间数据  -->
    <el-drawer class="batch-add-area-drawer" :title="batchAddAreaDrawerTtile" :wrapperClosable="false"
      :visible.sync="batchAddAreaDrawerDrawer" :before-close="handleCloseBatchAddAreaDrawerDrawer">
      <div class="batch-add-area-main">
        <div class="batch-add-area-title">选择地区</div>
        <div class="area">
          <div class="check-china">
            <el-checkbox v-model="checkedChina" @change="changeCheckedChina">中国</el-checkbox>
          </div>
          <div class="provinces-city" :class="closeAreaRangeData?'provinces-city-active':''" v-if="batchAddAreaDrawerDrawer">
            <el-cascader-panel ref="provincesCity" v-model="selectArea" :props="defaultParams"
              :options="provincesAndCitiesAddressList" @change="changeArea"></el-cascader-panel>
          </div>
          <p class="select-area-title">已选地区</p>
          <div class="select-area-content">
            <div class="select-area-name" v-for="(item, index) in selectUpdateArea" :key="index">
              {{ item.childrenName ? item.childrenName : item.name }}
            </div>
          </div>
        </div>
        <div v-if="!closeAreaRangeData" class="batch-add-area-title">录入数据</div>
        <div v-if="!closeAreaRangeData" class="area-data">
          <div class="area-data-row" v-for="(item, index) in areaRangeData" :key="index">
            <div class="rang">{{ item.value }}kg</div>
            <div class="weight-title">
              <div :class="item.fixedPrice ? 'rang-first-weight-active' : 'rang-first-weight'">
                {{`首重（${unit}）`}}
              </div>
              <div v-if="!item.fixedPrice" class="rang-continuation-weight">{{`续重（${unit}）`}}</div>
            </div>
            <div class="weight-content">
              <div :class="item.fixedPrice ? 'rang-first-weight-content-active' : 'rang-first-weight-content'">
                <el-input class="white" v-model="item.firstWeight" placeholder="请输入" @input="inputPriceRangeLimit(
              index,
              'firstWeight',
              item.firstWeight
            )"></el-input>
              </div>
              <div class="rang-continuation-weight-content" v-if="!item.fixedPrice">
                <el-input class="white" v-model="item.overPrice" placeholder="请输入" @input="inputPriceRangeLimit(
              index,
              'overPrice',
              item.overPrice
            )"></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseBatchAddAreaDrawerDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submitBatchAddAreaDrawer">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Logistics from "models/logistics";
const logistics = new Logistics();
import ExpressInquiry from "models/express-inquiry";
const expressInquiry = new ExpressInquiry();
import statusMixins from '@/common/mixins/status'
import addressMixins from "@/common/mixins/address.js"
import toolTip from '@/components/base/toolTip.vue'
export default {
  mixins: [statusMixins, addressMixins],
  components: {
    toolTip
  },

  data() {
    return {
      // 列表id
      id: null,
      companyId: null,
      warehouseId: null,
      warehouseName: null,
      // 1:新增；2：编辑：3：详情
      isFlag: null,
      logisticsForm: {
        logisticsType: '',
        expressName: '',
        expressType: null,
        expressMethod: '',
        expressMethodName: ''
      },
      
      templateDrawer: false,
      templateForm: {
        templateId: '',
      },
      templateList: [],
      
      editSectionDrawer: false,
      
      activeTableIndex: 0,
      // 取整规则
      expressRuleRoundTypeReqVoList: [],
      tableList: [],
      roundList: [],
      tableName: '',
      // 表格区间标题
      tableTitle: [],
      tableData: [],
      // 表格区间
      sectionList: [],
      unit: 'kg',

      setTemplateDrawer: false,
      setTemplateForm: {
        templateName: ''
      },
      setTemplateFormRules: {
        templateName: {
          required: true,
          message: "请输入模板名称",
          trigger: "blur",
        },
      },

      // 批量修改地区规则开关
      batchAddAreaDrawerDrawer: false,
      // 批量修改地区规则标题
      batchAddAreaDrawerTtile: '添加地区',
      // 是否选择中国
      checkedChina: false,
      // 回显用到数据
      selectArea: [],
      // 选中上传给后端的数据
      selectUpdateArea: [],
      // 地区范围数据
      areaRangeData: [],
      // 是否关闭地区录入数据
      closeAreaRangeData: false,
      // 当前地区下标
      areaTableIndex: 0,
    }
  },

  async created() {
    await this.initCommon()
  },
  async activated() {
    await this.initCommon()
  },

  methods: {
    async initCommon() {
      this.id = await Number(this.$route.query.id);
      this.companyId = await Number(this.$route.query.companyId);
      this.warehouseId = await Number(this.$route.query.warehouseId);
      this.logisticsForm.logisticsType = await Number(this.$route.query.expressType);
      this.logisticsForm.expressMethod = await Number(this.$route.query.expressMethod);
      this.warehouseName = this.$route.query.warehouseName
      this.logisticsForm.expressName = this.$route.query.expressName
      this.logisticsForm.expressMethodName = this.EXPRESS_TYPE[this.logisticsForm.expressMethod]
      this.isFlag = Number(this.$route.query.isFlag);
      this.initTemplateList()
      this.initGetRoundList()
      this.initDetails(this.warehouseId, this.logisticsForm.logisticsType, this.logisticsForm.expressMethod, this.companyId)
    },

    /**
     * @desc 获取取整规则
     */
    initGetRoundList() {
      logistics.getRoundList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.code;
            obj.name = value.name;
            arr.push(obj);
          });
          this.roundList = arr
        }
      })
    },

    /** 
     * @desc 获取模板列表
    */
    initTemplateList() {
      let logisticCompanyId = this.companyId
      let data = {
        logisticCompanyId
      }
      logistics.postTemplateList(data).then(async (res) => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.logisticCompanyId = i.logisticCompanyId
            obj.expressType = i.expressType
            obj.warehouseId = i.warehouseId
            obj.name = i.templateName
            arr.push(obj)
          })
          this.templateList = arr
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 模板详情接口 */
    initDetails(warehouseId, expressType, expressMethod, logisticCompanyId) {
      expressInquiry
        .getExpressDetail(warehouseId, expressType, expressMethod, logisticCompanyId)
        .then(async (res) => {
          if (res.success) {
              if (res.result.length === 0) {
                this.$message.error("无该模板");
                return false;
              }
              let { ruleList } = res.result
              let tableList = []
              if (ruleList) {
                ruleList.map(j => {
                  let obj2 = {}
                  obj2.name = `表格${j.sort}`
                  obj2.expressRuleRoundTypeReqVoList = j.roundTypeList
                  obj2.sectionList = []
                  obj2.tableTitle = []
                  obj2.tableData = []
                  j.section.map(k => {
                    let obj3 = {}
                    let obj4 = {}
                    obj3.begin = k.begin
                    obj3.end = k.end
                    obj3.unitWeight = k.unitWeight
                    obj4.value = k.begin + "-" + k.end;
                    obj4.unitWeight = k.unitWeight;
                    obj2.sectionList.push(obj3)
                    obj2.tableTitle.push(obj4);
                  })

                  j.rules.map(r => {
                    let obj5 = {}
                    obj5.province = r.province
                    obj5.ruleDetail = r.ruleDetail;
                    r.ruleDetail.map(v => {
                      if (v.over === 0) {
                        obj5[v.begin + "-" + v.end] = v.price;
                      } else {
                        obj5[v.begin + "-" + v.end] = {};
                        obj5[v.begin + "-" + v.end].overPrice = v.over;
                        obj5[v.begin + "-" + v.end].firstWeight = v.price;
                      }
                      obj2.sectionList.map((val) => {
                        if (val.begin === v.begin && val.end === v.end) {
                          val.unitWeight = v.unitWeight;
                          if (v.over === 0) {
                            val.fixedPrice = true;
                          } else {
                            val.fixedPrice = false;
                          }
                        }
                      });
                      obj2.tableTitle.map(val => {
                        let str = v.begin + "-" + v.end
                        if (val.value === str) {
                          if (v.over === 0) {
                            val.fixedPrice = true
                          } else {
                            val.fixedPrice = false
                          }
                        }
                      })
                    })
                    obj2.tableData.push(obj5)
                  })

                  obj2.tableData.map(o => {
                    o.ruleDetail.map(v=> {
                      obj2.sectionList.map((val) => {
                        if (val.begin === v.begin && val.end === v.end) {
                          let str = v.begin + "-" + v.end;
                          if (!val.fixedPrice) {
                            o[str] = {}
                            o[str].overPrice = v.over;
                            o[str].firstWeight = v.price;
                          }
                        }
                      });
                    })
                  })
                  
                  if (j.roundTypeList.length === 0 || j.roundTypeList === null) {
                    let roundArr = [
                      {
                        begin: 0,
                        end: "9999.9",
                        roundType: this.roundList[0].id,
                      },
                    ]
                    obj2.expressRuleRoundTypeReqVoList = roundArr
                  } else {
                    obj2.expressRuleRoundTypeReqVoList = j.roundTypeList
                  }
                  tableList.push(obj2)
                })
                this.tableList = tableList
                if (tableList.length) {
                  this.tableData = tableList[0].tableData
                  this.selectTable(tableList[0], 0)
                }
              }
          } else {
            this.$message.error(res.message);
          }
        });
    },

    async getData() {
      if (this.tableList.length) {
        this.tableList[this.activeTableIndex].tableData = await this.tableData
      }
    },
    
    async selectTable(row, index) {
      await this.getData()
      this.activeTableIndex = index
      this.tableName = row.name
      this.tableTitle = row.tableTitle
      this.tableData = row.tableData
      this.sectionList = row.sectionList
      this.expressRuleRoundTypeReqVoList = row.expressRuleRoundTypeReqVoList
    },
    
    addTable() {
      let name = `表格${this.tableList.length+1}`
      let expressRuleRoundTypeReqVoList = [
        {
          begin: 0,
          end: "9999.9",
          roundType: this.roundList[0].id,
        },
      ]
      let tableData = []
      let sectionList = [
        {
          begin: 0,
          end: "",
          unitWeight: 0,
          fixedPrice: false,
        },
        {
          begin: '',
          end: "9999.9",
          unitWeight: 1,
          fixedPrice: false,
        }
      ]
      let obj = {
        name,
        // 取整规则
        expressRuleRoundTypeReqVoList,
        // 表格列表
        tableData,
        // 表格区间
        sectionList,
        // 表格标题区间
        tableTitle: []
      }
      this.tableList.push(obj)
      this.expressRuleRoundTypeReqVoList = this.tableList[this.activeTableIndex].expressRuleRoundTypeReqVoList
      this.tableName = this.tableList[this.activeTableIndex].name
      this.tableTitle = this.tableList[this.activeTableIndex].tableTitle
      this.tableData = this.tableList[this.activeTableIndex].tableData
      this.sectionList = this.tableList[this.activeTableIndex].sectionList
    },
    
    closeTable(index) {
      this.tableList.splice(index,1)
    },
    
    /**
     * @desc 上一个区间的右区间的值带入下一个区间的左区间的值
     */
    blurRoundTableTitle(index, value) {
      if (!Number.isNaN(Number(value)) && Number(value) > 0) {
        this.expressRuleRoundTypeReqVoList[index + 1].begin = value;
      } else {
        this.expressRuleRoundTypeReqVoList[index].end = "";
        this.expressRuleRoundTypeReqVoList[index + 1].begin = "";
      }
    },

    /**
     * @desc 限制区间大于9999.9
     */
    inputRoundEnd(index, val) {
      if (Number(val) >= 9999.9) {
        this.expressRuleRoundTypeReqVoList[index].end = 9999.9
      }
    },
    
    /** 
     * @desc 添加取整规则区间
    */
    addSection() {
      let lengthFirst = this.expressRuleRoundTypeReqVoList.length - 1;
      let endVal = this.expressRuleRoundTypeReqVoList[lengthFirst].end
      let index
      let obj
      if (endVal != 9999.9) {
        obj = {
          begin: this.expressRuleRoundTypeReqVoList[lengthFirst].end,
          end: "9999.9",
          roundType: this.roundList[0].id
        };
        index = this.expressRuleRoundTypeReqVoList.length;
      } else {
        obj = {
          begin: this.expressRuleRoundTypeReqVoList[lengthFirst].begin,
          end: "",
          roundType: this.roundList[0].id
        };
        index = this.expressRuleRoundTypeReqVoList.length - 1;
        this.expressRuleRoundTypeReqVoList[lengthFirst].begin = ''
      }
      this.expressRuleRoundTypeReqVoList.splice(index, 0, obj);
    },
    
    /** 
     * @desc 删除取整规则区间
    */
    deleteSection(index) {
      this.expressRuleRoundTypeReqVoList.splice(index, 1);
      let lengthFirst = this.expressRuleRoundTypeReqVoList.length - 1;
      this.expressRuleRoundTypeReqVoList[lengthFirst].end = 9999.9
    },

    addTableData() {
      if (this.tableTitle.length === 0) {
        this.$message.error("请添加区间");
      } else {
        this.areaRangeData = JSON.parse(JSON.stringify(this.tableTitle))
        this.closeAreaRangeData = false
        this.batchAddAreaDrawerDrawer = true
      }
    },
    
    removeTableData(index) {
      this.tableData.splice(index, 1);
    },
    
    /** 
     * @desc 限制小数点后三位
    */
    inputPriceLimit(row, index, type, val) {
      if (val == ".") {
        val = "";
      }
      let numLimit = val.toString().match(/^\d*(\.?\d{0,3})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*(\.?\d{0,3})/g)[0]
        : "";
      if (type === "firstWeight") {
        row[index].firstWeight = numLimit;
      } else if (type === "overPrice") {
        row[index].overPrice = numLimit;
      } else {
        row[index] = numLimit;
      }
      
      if (this.tableList.length) this.tableList[this.activeTableIndex].tableData = this.tableData
    },


    /** 
     * @desc 限制小数点后三位
    */
    inputPriceRangeLimit(index, type, val) {
      if (val == ".") {
        val = "";
      }
      let numLimit = val.toString().match(/^\d*(\.?\d{0,3})/g)
        ? val === "00"
          ? "0"
          : val.toString().match(/^\d*(\.?\d{0,3})/g)[0]
        : "";

      this.$set(this.areaRangeData[index], type, numLimit)
    },
    
    async saveExpressRules() {
      await this.getData()
      let obj = {}
      obj.logisticCompanyId = this.companyId;
      obj.expressType = this.logisticsForm.logisticsType
      obj.expressMethod = this.logisticsForm.expressMethod
      obj.warehouseId = this.warehouseId;
      for(let i = 0; i < this.tableList.length; i++) {
        let jIndex = i
        let j = this.tableList[i]
        if (this.activeTableIndex === jIndex) {
          if (j.tableData.length > 0) {
            let arr = [];
            let stop = false;
            let onlyArea = false
            let duplicateAreaName = ''
            let areaList = []
            let num = 0;
            j.tableData.map((value) => {
              value.province.split(';').map(areaVal => {
                areaVal.split(',').map(a => {
                  if (areaList.indexOf(a) === -1) {
                    areaList.push(a)
                  } else {
                    duplicateAreaName += `${a};`
                    onlyArea = true
                  }
                })
              })
              num = 0;
              Object.keys(value).forEach((key) => {
                j.tableTitle.map((v) => {
                  if (v.value === key) {
                    num = num + 1;
                    let obj3 = {};
                    obj3.province = value.province;
                    obj3.unitWeight = v.unitWeight
                    obj3.begin = Number(key.split("-")[0]);
                    obj3.end = Number(key.split("-")[1]);
                    if (v.fixedPrice) {
                      obj3.price = Number(value[key]);
                      obj3.over = 0;
                      obj3.fixedPrice = 1;
                    } else {
                      obj3.price = Number(value[key].firstWeight);
                      obj3.over =  Number(value[key].overPrice);
                      obj3.fixedPrice = 0;
                    }
                    if (value.province === "" || value[key] === "") {
                      stop = true;
                    }
                    arr.push(obj3);
                  }
                });
              });
            });
            let isOver = false;
            arr.map((k) => {
              if ((k.over == "" || k.over == 0) && k.fixedPrice == 0) {
                isOver = true;
              }
            });
            if (onlyArea) {
              this.$message.error(`${duplicateAreaName}区域重复`);
              return;
            }
            if (isOver) {
              this.$message.error("续重不能为空和0");
              return;
            }
            if (num !== j.tableTitle.length) {
              this.$message.error("地区或区域价格不能为空");
              return;
            }
            if (!stop) {
              obj.list = arr;
              obj.sort = jIndex + 1;
              obj.roundTypeList = j.expressRuleRoundTypeReqVoList
            } else {
              this.$message.error("地区或区域价格不能为空");
              return
            }
          } else {
            this.$message.error("请添加规则");
            return
          }
        }
      }
      expressInquiry.postExpressAddRule(obj).then((res) => {
        if (res.success) {
          this.$message.success("添加成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /** 
     * @desc 保存现场定价
    */
    saveScenePriceExpressRules() {
      let data = {};
      data.logisticCompanyId = this.companyId;
      data.expressType = this.logisticsForm.logisticsType
      data.expressMethod = this.logisticsForm.expressMethod
      data.warehouseId = this.warehouseId;
      expressInquiry.postExpressAddRule(data).then((res) => {
        if (res.success) {
          this.$message.success("添加成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    openEditSectionDrawer() {
      if (this.tableList.length) this.editSectionDrawer = true
    },

    handleCloseEditSectionDrawer() {
      this.editSectionDrawer = false
    },
    
    blurTableTitle(index, value) {
      if (!Number.isNaN(Number(value)) && Number(value) > 0) {
        this.sectionList[index + 1].begin = value;
        if (this.sectionList[index].begin < 1) {
          this.sectionList[index].fixedPrice = true;
        }
      } else {
        this.sectionList[index].end = "";
        this.sectionList[index + 1].begin = "";
      }
    },

    addTableSection() {
      let length = this.sectionList.length - 2;
      let lengthFirst = this.sectionList.length - 1;
      let endVal = this.sectionList[lengthFirst].end
      let index
      let obj
      if (endVal != 9999.9) {
        obj = {
          begin: this.sectionList[lengthFirst].end,
          end: "9999.9",
          fixedPrice: false,
          unitWeight: 1,
        };
        index = this.sectionList.length;
      } else {
        obj = {
          begin: this.sectionList[length].end,
          end: "",
          fixedPrice: false,
          unitWeight: 1,
        };
        index = this.sectionList.length - 1;
        this.sectionList[lengthFirst].start = ''
      }
      this.sectionList.splice(index, 0, obj);
    },

    /**
     * @desc 删除表格区间
     */
    delTableSection(index) {
      this.sectionList.splice(index, 1);
      let length = this.sectionList.length - 2;
      let lengthFirst = this.sectionList.length - 1;
      this.sectionList[lengthFirst].begin = this.sectionList[length].end
    },

    submitEditSectionDrawer() {
      this.restructureTableSection()
    },

    /**
     * @desc 重构表格区间
     */
    restructureTableSection() {
      let tableTitle = [];
      let isStop = false;
      let isFlag = false;
      let isFirstWeightVal = false;
      let isFirstWeight = false;
      this.sectionList.map((value) => {
        let obj = {};
        obj.value = value.begin + "-" + value.end;
        obj.fixedPrice = value.fixedPrice;
        obj.unitWeight = value.unitWeight;
        obj.firstWeight = "";
        obj.overPrice = "";
        tableTitle.push(obj);
        if (value.begin === "" || value.end === "") {
          isStop = true;
          return false;
        }
        if (Number(value.begin) >= Number(value.end)) {
          isFlag = true;
          return;
        }
        if (value.unitWeight === '') {
          isFirstWeightVal = true;
          return;
        }
        if (Number(value.unitWeight) > Number(value.begin)) {
          isFirstWeight = true;
          return;
        }
      });
      if (isStop) {
        this.$message.error("区间价不能为空");
        return false;
      }
      if (isFlag) {
        this.$message.error("左区间必须小于右区间");
        return false;
      }
      if (isFirstWeightVal) {
        this.$message.error("首重不能为空");
        return false;
      }
      if (isFirstWeight) {
        this.$message.error("首重要小于等于左区间");
        return false;
      }
      let tableData = [];
      this.tableData.map((i) => {
        let obj = {};
        obj.province = i.province;
        tableTitle.map((val) => {
          if (val.fixedPrice) {
            obj[val.value] = "";
          } else {
            obj[val.value] = {};
            obj[val.value].firstWeight = "";
            obj[val.value].overPrice = "";
          }
          Object.keys(i).forEach((key) => {
            if (key === val.value) {
              if (val.fixedPrice) {
                if (typeof i[key] === "object") {
                  obj[val.value] = Number(i[key].firstWeight);
                } else {
                  obj[val.value] = Number(i[key]);
                }
              } else {
                if (typeof i[key] === "object") {
                  if (i[key].firstWeight) {
                    obj[val.value].firstWeight = Number(i[key].firstWeight);
                  } else {
                    obj[val.value].firstWeight = '';
                  }
                } else {
                  obj[val.value].firstWeight = Number(i[key]);
                }
                if (i[key].overPrice) {
                  obj[val.value].overPrice = Number(i[key].overPrice);
                } else {
                  obj[val.value].overPrice = '';
                }
              }
            }
          });
        });
        tableData.push(obj);
      });
      this.tableData = [...tableData];
      this.tableTitle = tableTitle;
      this.tableList[this.activeTableIndex].tableData = tableData
      this.tableList[this.activeTableIndex].tableTitle = tableTitle
      this.handleCloseEditSectionDrawer()
    },

    openTemplateDrawer() {
      this.templateDrawer = true
    },

    handleCloseTemplateDrawer() {
      this.templateForm.templateId = ''
      this.templateDrawer = false
    },
    
    submitTemplateForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let templateId = this.templateForm.templateId;
          let obj = this.templateList.find(item => { return item.id == templateId })
          this.initDetails(obj.warehouseId, obj.expressType, obj.expressMethod, this.companyId)
          this.handleCloseTemplateDrawer()
        } else {
          return false;
        }
      });
    },

    openSetTemplateDrawer() {
      this.setTemplateDrawer = true
    },

    handleCloseSetTemplateDrawer() {
      this.$refs['setTemplateForm'].resetFields();
      this.setTemplateDrawer = false
    },
    
    submitSetTemplateDrawerForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let id = this.id
          let isTemplate = 1
          let templateName = this.setTemplateForm.templateName
          let data = {
            id,
            isTemplate,
            templateName
          }
          logistics.postSetTemplateName(data).then(async (res) => {
            if (res.success) {
              this.initTemplateList()
              this.handleCloseSetTemplateDrawer()
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },



    /** 
     * @description 开启地区编辑
    */
    openModArea(index, areaVal) {
      this.closeAreaRangeData = true
      this.areaTableIndex = index
      if (areaVal) {
        if (areaVal === '中国') {
          this.disabledProvincesAndCitiesAddress(true)
        } else {
          this.disabledProvincesAndCitiesAddress(false)
          let selectUpdateAreaArr = []
          areaVal.split(';').map(i => {
            i.split(',').map(j => {
              this.selectAllChildren(this.provincesAndCitiesAddressList, j)
              selectUpdateAreaArr.push(this.areaTranslation(this.provincesAndCitiesAddressList, j))
            })
          })
          this.selectUpdateArea = this.mergeSimilarItems(selectUpdateAreaArr)
        }
      }
      this.batchAddAreaDrawerDrawer = true
    },

    /** 
     * @description 把地区转译成父子结构
    */
    areaTranslation(nodes, name) {
      let obj = {}
      nodes.forEach(node => {
        if (node.name === name) {
          obj.name = node.name
          obj.childrenName = ''
        } else {
          if (node.children && node.children.length > 0) {
            node.children.forEach(childNode => {
              if (childNode.name === name) {
                obj.name = node.name
                obj.childrenName = childNode.name
              }
            })
          }
        }
      })
      return obj
    },

    /** 
     * @description 根据父级地区获取子级地区
    */
    selectAllChildren(nodes, name) {
      nodes.forEach(node => {
        if (node.name === name) {
          this.selectNode(node);
        }
        if (node.children && node.children.length > 0) {
          this.selectAllChildren(node.children, name);
        }
      });
    },
    selectNode(node) {
      this.selectArea.push(node.name);
      if (node.children) {
        node.children.forEach(child => {
          this.selectNode(child);
        });
      }
    },


    /**
     * @description 关闭批量修改地区规则
     */
    handleCloseBatchAddAreaDrawerDrawer() {
      this.selectArea = []
      this.areaRangeData = []
      this.selectUpdateArea = []
      this.batchAddAreaDrawerDrawer = false
    },

    /** 
     * @desc 选中中国地区
    */
    changeCheckedChina(v) {
      this.disabledProvincesAndCitiesAddress(v)
    },

    /** 
     * @description 是否禁用省市选择
    */
    disabledProvincesAndCitiesAddress(v) {
      this.checkedChina = v
      this.provincesAndCitiesAddressList.map(i => {
        i.disabled = v
        if (i.children) {
          i.children.map(j => {
            j.disabled = v
          })
        }
      })
      this.selectArea = []
      this.selectUpdateArea = []
      if (v) {
        this.selectUpdateArea = [
          { name: '中国', childrenName: '' }
        ]
      }
    },

    changeArea(v) {
      let checkedNodeList = this.$refs['provincesCity'].getCheckedNodes()
      // 判断所有子级选中,取父级
      checkedNodeList = checkedNodeList.filter(item => !(item.parent && item.parent.checked))
      let arr = []
      checkedNodeList.map(i => {
        let obj = {}
        obj.childrenName = ''
        if (i.parent) {
          obj.childrenName = i.label
          obj.name = i.parent.label
        } else {
          obj.name = i.label
        }
        arr.push(obj)
      })
      this.selectUpdateArea = this.mergeSimilarItems(arr)
    },

    /** 
     * @description 合并同类项
    */
    mergeSimilarItems(arr) {
      return arr.reduce((acc, current) => {
        const existingItemIndex = acc.findIndex(item => item.name === current.name);
        if (existingItemIndex >= 0) {
          // 如果已存在相同id的项，则合并数据
          acc[existingItemIndex].childrenName += `,${current.childrenName}`;
        } else {
          // 如果不存在，直接添加到结果数组
          acc.push({ ...current });
        }
        return acc;
      }, []);
    },

    /** 
     * @description 保存批量修改地区规则
    */
    submitBatchAddAreaDrawer() {
      let obj = {};
      obj.province = "";
      this.selectUpdateArea.map(i => {
        if (i.childrenName) {
          obj.province += `;${i.childrenName}`
        } else {
          obj.province += `;${i.name}`
        }
      })
      obj.province = obj.province.substr(1)
      if (!this.closeAreaRangeData) {
        this.areaRangeData.map((i) => {
          if (i.fixedPrice) {
            obj[i.value] = i.firstWeight;
          } else {
            obj[i.value] = {};
            obj[i.value].firstWeight = i.firstWeight;
            obj[i.value].overPrice = i.overPrice;
          }
        });
        this.tableData.push(obj);
      } else {
        this.tableData[this.areaTableIndex].province = obj.province
      }
      this.handleCloseBatchAddAreaDrawerDrawer()
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/system/express-rules.scss';
</style>
